import _ from "lodash";
import { bindActionCreators } from "redux";
import { delay } from "redux-saga";
import { call, put, select, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";
import datetimeHelper from "./../../helper/datetime-helper";

export const MONITOR_REALTIME = "MONITOR_REALTIME";
export const MONITOR_REALTIME_ERROR = "MONITOR_REALTIME_ERROR";
export const MONITOR_REALTIME_SUCCESS = "MONITOR_REALTIME_SUCCESS";

export const SPY_CALL = "SPY_CALL";
export const SPY_CALL_SUCCESS = "SPY_CALL_SUCCESS";
export const SPY_CALL_ERROR = "SPY_CALL_ERROR";

export const CAMPAIGNS_REALTIME = "CAMPAIGNS_REALTIME";
export const CAMPAIGNS_REALTIME_SUCCESS = "CAMPAIGNS_REALTIME_SUCCESS";
export const CAMPAIGNS_REALTIME_ERROR = "CAMPAIGNS_REALTIME_ERROR";

export const AGENT_CALLS_REALTIME = "AGENT_CALLS_REALTIME";
export const AGENT_CALLS_REALTIME_SUCCESS = "AGENT_CALLS_REALTIME_SUCCESS";
export const AGENT_CALLS_REALTIME_ERROR = "AGENT_CALLS_REALTIME_ERROR";

export const CALLS_REALTIME = "CALLS_REALTIME";
export const CALLS_REALTIME_SUCCESS = "CALLS_REALTIME_SUCCESS";
export const CALLS_REALTIME_ERROR = "CALLS_REALTIME_ERROR";

export const GET_CHAT_AGENTS = "GET_CHAT_AGENTS";
export const GET_CHAT_AGENTS_SUCCESS = "GET_CHAT_AGENTS_SUCCESS";
export const GET_CHAT_AGENTS_ERROR = "GET_CHAT_AGENTS_ERROR";

/**
 * Reducer
 */

const initialState = {
  monitor: [],
  error: false,
  loading: false,
  spy: {},
  campaigns: [],
  agentCalls: [],
  calls: [],
};

export const monitorRealtimeReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case MONITOR_REALTIME:
      return {
        ...state,
        loading: true,
      };
    case MONITOR_REALTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        monitor: action.payload,
      };
    case MONITOR_REALTIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //spy
    case SPY_CALL:
      return {
        ...state,
        loading: true,
      };
    case SPY_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        spy: action.payload,
      };
    case SPY_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //campaigns
    case CAMPAIGNS_REALTIME:
      return {
        ...state,
        loading: true,
      };
    case CAMPAIGNS_REALTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: action.payload,
      };
    case CAMPAIGNS_REALTIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //agent calls
    case AGENT_CALLS_REALTIME:
      return {
        ...state,
        loading: true,
      };
    case AGENT_CALLS_REALTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        agentCalls: action.payload,
      };
    case AGENT_CALLS_REALTIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //agent calls
    case CALLS_REALTIME:
      return {
        ...state,
        loading: true,
      };
    case CALLS_REALTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        calls: action.payload,
      };
    case CALLS_REALTIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //chat agents
    case GET_CHAT_AGENTS:
      return {
        ...state,
        loadingChatAgents: true,
      };
    case GET_CHAT_AGENTS_SUCCESS:
      return {
        ...state,
        loadingChatAgents: false,
        chatAgents: action.payload,
      };
    case GET_CHAT_AGENTS_ERROR:
      return {
        ...state,
        loadingChatAgents: false,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const monitorRealtime = () => ({
  type: MONITOR_REALTIME,
});

export const spyCall = (id, mode, extensionId) => ({
  type: SPY_CALL,
  data: {
    id,
    mode,
    extensionId,
  },
});

export const campaignsRealtime = () => ({
  type: CAMPAIGNS_REALTIME,
});

export const agentCallsRealtime = (number, groupId, subOrgs) => ({
  type: AGENT_CALLS_REALTIME,
  data: { number, groupId, subOrgs },
});

export const callsRealtime = (number, groupId) => ({
  type: CALLS_REALTIME,
  data: {
    number,
    groupId,
  },
});

export const getChatAgents = (params) => ({
  type: GET_CHAT_AGENTS,
  data: params,
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      monitorRealtime,
      spyCall,
      campaignsRealtime,
      agentCallsRealtime,
      callsRealtime,
      getChatAgents,
    },
    dispatch
  );
};

/**
 * Apis
 */
const getListStatusApi = () => {
  return apiCaller.get(
    `/call-center/agent-status?filter={"where": {"id": {"neq": "stop"}}}`
  );
};

const monitorRealtimeApi = () => {
  return apiCaller.get("mini-crm/monitor/realtime");
};

// const agentCallsRealtimeApi = (number, groupId) => {
//     return apiCaller.getData('mini-crm/monitor/agents-calls-realtime', { number, groupId })
// }

const agentCallsRealtimeApi = (number, groupId, subOrgs = []) => {
  let params = { filter: { number, groupId } };
  const and = [];
  if (subOrgs.length) {
    and.push({ subOrg: { inq: subOrgs } });
    params.filter.where = { and };
  }

  return apiCaller.getData("call-center/agent", params);
};

const callsRealtimeApi = (number, groupId) => {
  return apiCaller.getData("mini-crm/monitor/calls-realtime", number, groupId);
};

const campaignsRealtimeApi = () => {
  return apiCaller.get("mini-crm/monitor/campaigns-realtime");
};

const spyCallApi = (id, mode, extensionId) => {
  return apiCaller.post(`cloud-pbx/active-call/${id}/spy`, {
    mode,
    extensionId,
  });
};

const getChatAgentsApi = (params) => {
  return apiCaller.getData(`/call-center/agent/chat`, params);
};

/**
 * sagas
 */

export const monitorRealtimeFlow = function* () {
  while (true) {
    yield take(MONITOR_REALTIME);
    try {
      const listStatus = yield call(getListStatusApi);

      const res = yield call(monitorRealtimeApi);
      for (const key in listStatus.data) {
        if (listStatus.data.hasOwnProperty(key)) {
          const status = listStatus.data[key];
          const checkStatus = res.data.agents.filter(
            (item) => item.statusId == status.id
          );
          if (checkStatus) {
            res.data[status.id] = checkStatus;
          }
        }
      }
      yield put({ type: MONITOR_REALTIME_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: MONITOR_REALTIME_ERROR, error });
    }
  }
};

export const spyCallFlow = function* () {
  while (true) {
    const action = yield take(SPY_CALL);
    try {
      const res = yield call(
        spyCallApi,
        action.data.id,
        action.data.mode,
        action.data.extensionId
      );
      yield put({
        type: SPY_CALL_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({
        type: SPY_CALL_ERROR,
        error,
      });
    }
  }
};

export const campaignsRealtimeFlow = function* () {
  while (true) {
    yield take(CAMPAIGNS_REALTIME);
    try {
      const res = yield call(campaignsRealtimeApi);
      const data = res.data;
      data.campaigns.forEach((item) => {
        const connected = item
          ? item.total != 0
            ? (item.connected / item.total) * 100
            : 0
          : 0;
        item.connected =
          item.connected !== null
            ? `${item.connected} (${connected.toFixed(2)}%)`
            : item.connected;
        item.startAt =
          (item.startAt && item.endAt) !== null
            ? `${datetimeHelper.toFormat(
                item.startAt,
                "YYYY-MM-DD"
              )} đến ${datetimeHelper.toFormat(item.endAt, "YYYY-MM-DD")}`
            : item.startAt;
      });
      yield put({
        type: CAMPAIGNS_REALTIME_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({
        type: CAMPAIGNS_REALTIME_ERROR,
        error,
      });
    }
  }
};

function customComparator(a, b) {
  return a.extensionId == b.extensionId;
}

export const callsRealtimeFlow = function* () {
  while (true) {
    const action = yield take(CALLS_REALTIME);
    try {
      const res = yield call(
        callsRealtimeApi,
        action.data.number,
        action.data.groupId
      );
      const _agentCalls = yield select((state) => state.monitor.agentCalls);
      let calls = [];
      calls = res.data.inboundCalls.concat(res.data.outboundCalls);
      if (calls.length != 0) {
        const _calls = calls.filter(
          (item) => item.status == "answering" && item.extension.id !== ""
        );
        if (_calls) {
          res.data["agentTalking"] = _calls.length;
        }
      }

      const callTimeIn = res.data?.inboundCalls || [];
      const callTimeOut = res.data?.outboundCalls || [];

      const agentCallInbound = _agentCalls?.agentCallInbound || [];
      const agentCallOutbound = _agentCalls?.agentCallOutbound || [];
      agentCallInbound.map((item) => {
        const callTime = callTimeIn.find(
          (dataIn) => dataIn.extensionId == item.extensionId
        );
        item.bridgedDuration = callTime.bridgedDuration;
      });

      agentCallOutbound.map((item) => {
        const callTime = callTimeOut.find(
          (dataOut) => dataOut.extensionId == item.extensionId
        );
        item.bridgedDuration = callTime.bridgedDuration;
      });

      _agentCalls["agentCallInbound"] = [...agentCallInbound];
      _agentCalls["agentCallOutbound"] = [...agentCallOutbound];

      yield put({ type: AGENT_CALLS_REALTIME_SUCCESS, payload: _agentCalls });
      yield put({ type: CALLS_REALTIME_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({
        type: CALLS_REALTIME_ERROR,
        error,
      });
    }
  }
};

export const agentCallsRealtimeFlow = function* () {
  let skipAtFirstTime = true;
  while (true) {
    const action = yield take(AGENT_CALLS_REALTIME);
    try {
      const listStatus = yield call(getListStatusApi);
      const _calls = yield select((state) => state.monitor.calls);
      const res = yield call(
        agentCallsRealtimeApi,
        action.data.number,
        action.data.groupId,
        action.data.subOrgs
      );
      let dataStatus = [];
      for (const key in listStatus.data) {
        if (listStatus.data.hasOwnProperty(key)) {
          const status = listStatus.data[key];
          const checkStatus = res.data.filter(
            (item) => item.statusId == status.id
          );
          let a = [];
          if (checkStatus) {
            for (const key in checkStatus) {
              if (checkStatus.hasOwnProperty(key)) {
                const _data = checkStatus[key];
                if (_calls) {
                  // if (_data.available == true) {
                  const inbound =
                    _calls.inboundCalls != undefined
                      ? _calls.inboundCalls.find(
                          (item) =>
                            item.extension.id == _data.extensionId &&
                            item.agent.id == _data.id &&
                            item.status == "answering"
                        )
                      : undefined;
                  const outbound =
                    _calls.outboundCalls != undefined
                      ? _calls.outboundCalls.find(
                          (item) =>
                            item.extension.id == _data.extensionId &&
                            item.agent.id == _data.id &&
                            item.status == "answering"
                        )
                      : undefined;
                  if (outbound != undefined || inbound != undefined) {
                    if (inbound != undefined) {
                      inbound["cdrId"] = inbound.id;
                      inbound["statusCall"] = inbound.status;
                      inbound["extensionCall"] = inbound.extension;
                    }
                    if (outbound != undefined) {
                      outbound["cdrId"] = outbound.id;
                      outbound["statusCall"] = outbound.status;
                      outbound["extensionCall"] = outbound.extension;
                    }
                  }
                  _data["statusAgent"] = _data.status;
                  _data["extensionAgent"] = _data.extension;
                  a.push({ ..._data, ...outbound, ...inbound });
                  dataStatus[status.id] = a;
                  // }
                }
              }
            }
            res.data[status.id] = dataStatus[status.id];
          }
        }
      }
      let dataAgentTalking = [];
      let dataAgentReady = [];
      let dataAgent = [];
      let dataAgentInbound = [];
      let dataAgentOutbound = [];
      for (const key in res.data) {
        if (res.data.hasOwnProperty(key)) {
          const agent = res.data[key];
          if (agent) {
            // if(agent.available == true){
            agent["statusAgent"] = agent.status;
            agent["extensionAgent"] = agent.extension;
            if (_calls) {
              const inbound =
                _calls.inboundCalls != undefined
                  ? _calls.inboundCalls.find(
                      (item) =>
                        item.extension.id == agent.extensionId &&
                        item.agent.id == agent.id &&
                        item.status == "answering"
                    )
                  : undefined;
              const outbound =
                _calls.outboundCalls != undefined
                  ? _calls.outboundCalls.find(
                      (item) =>
                        item.extension.id == agent.extensionId &&
                        item.agent.id == agent.id &&
                        item.status == "answering"
                    )
                  : undefined;
              const outboundRing =
                _calls.outboundCalls != undefined
                  ? _calls.outboundCalls.find(
                      (item) =>
                        item.extension.id == agent.extensionId &&
                        item.agent.id == agent.id &&
                        item.status == "ringing"
                    )
                  : undefined;
              if (
                outbound != undefined ||
                inbound != undefined ||
                outboundRing !== undefined
              ) {
                if (inbound != undefined) {
                  inbound["cdrId"] = inbound.id;
                  inbound["statusCall"] = inbound.status;
                  inbound["extensionCall"] = inbound.extension;
                  dataAgentInbound.push({ ...agent, ...inbound });
                }
                if (outbound != undefined) {
                  outbound["cdrId"] = outbound.id;
                  outbound["statusCall"] = outbound.status;
                  outbound["extensionCall"] = outbound.extension;
                  dataAgentOutbound.push({ ...agent, ...outbound });
                }
                if (outboundRing != undefined) {
                  outboundRing["cdrId"] = outboundRing.id;
                  outboundRing["statusCall"] = outboundRing.status;
                  outboundRing["extensionCall"] = outboundRing.extension;
                  dataAgentOutbound.push({ ...agent, ...outboundRing });
                }
                dataAgentTalking.push({ ...agent, ...outbound, ...inbound });
              }
              dataAgent.push({ ...agent, ...outbound, ...inbound });
            }
            // }
          }
        }
      }
      res.data["agents"] = [...dataAgent];
      res.data["agentTalking"] = [...dataAgentTalking];
      res.data["agentCallInbound"] = dataAgentInbound;
      res.data["agentCallOutbound"] = dataAgentOutbound;

      if (res.data["service"] != undefined) {
        if (res.data["agentCallInbound"] != undefined) {
          const _dataAgentReady = _.remove(
            _.differenceWith(
              res.data["service"],
              res.data["agentCallInbound"],
              customComparator
            )
          );
          dataAgentReady = _dataAgentReady;
        }
      }
      res.data["agentReady"] = dataAgentReady;
      if (res.data["service"] !== undefined) {
        res.data["agentAvailable"] = res.data["service"];
        if (res.data["pause"] !== undefined) {
          res.data["agentAvailable"] = res.data["service"].concat(
            res.data["pause"]
          );
        }
      } else {
        res.data["agentAvailable"] = res.data["pause"];
      }
      const _dataAgentOuboundAvail = _.remove(
        _.differenceWith(
          res.data["manual"],
          dataAgentOutbound,
          customComparator
        )
      );
      res.data["agentOuboundAvail"] = _dataAgentOuboundAvail;
      if (!skipAtFirstTime) {
        skipAtFirstTime = false;
        yield delay(2000);
      }
      yield put({
        type: AGENT_CALLS_REALTIME_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({
        type: AGENT_CALLS_REALTIME_ERROR,
        error,
      });
    }
  }
};

export const getChatAgentsFlow = function* () {
  while (true) {
    const action = yield take(GET_CHAT_AGENTS);
    try {
      console.log("action.data", action.data);
      const res = yield call(getChatAgentsApi, action.data || {});
      yield put({ type: GET_CHAT_AGENTS_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({
        type: GET_CHAT_AGENTS_ERROR,
        error,
      });
    }
  }
};
